export const SET_TXT_RESOURCES = "SET_TXT_RESOURCES";
export const SET_LOADER = "SET_LOADER";
export const SET_LANGUAGE = "SET_LANGUAGE";
